import './AssinaturasFormularioAcompanhamento.css';

import menosIcon from '../../imagens/minus.png'
import maisIcon from '../../imagens/plus-sign.png'

function AssinaturasFormularioAcompanhamento({ assinaturas, coletaAssinatura, addAssinatura, removeAssinatura }) {

    console.log(assinaturas);

    const onAtualizar = (index, key, value) => {
        // esse if evita que valores vazios sejam enviados
        if (value) coletaAssinatura(index, key, value);
    };

    return (
        <div className='formAssinaturasContainer'>
            <table>
                <thead>
                    <tr>
                        <th>Nome Completo</th>
                        <th>Matrícula</th>
                        <th>Setor</th>
                    </tr>
                </thead>
                <tbody>

                    {assinaturas.map((assinatura, index) => (

                        <tr key={index}>
                            <td>
                                <input onBlur={(e) => onAtualizar(index, 'nomeCompleto', e.target.value)} maxLength={33} required></input>
                            </td>
                            <td>
                                <input onBlur={(e) => onAtualizar(index, 'matricula', e.target.value)} maxLength={33} required></input>
                            </td>
                            <td>
                                <input onBlur={(e) => onAtualizar(index, 'setor', e.target.value)} maxLength={33} required></input>
                            </td>
                            <td>
                                <div className='iconButtonAssinaturasContainer'>
                                    <img className='iconButtonAssinaturas' alt='icone de adicao' src={maisIcon} onClick={addAssinatura} />
                                    <img className='iconButtonAssinaturas' alt='icone de retirada' src={menosIcon} onClick={() => removeAssinatura(index)} />
                                </div>
                            </td>
                        </tr>

                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default AssinaturasFormularioAcompanhamento;
